module.exports = __webpack_public_path__ + "assets/images/template/image-background-header.jpg?v=005c2cf7";